/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowDownRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M10 18h8v-8h-1.5v5.5L7 6 6 7l9.5 9.5H10V18Z" />
	</SVG>
);

export default arrowDownRight;
